import { Gender, ProgramLevel } from '@/core/Programs'
import { AreasByPref } from '@/core/Facilities'
import { Activity } from '@/core/Activities'

export interface SearchState {
  conditions: {
    activityIds: number[]
    areaIds: number[]
    searchDates: string[]
    startTimeBefore: string
    startTimeAfter: string
    sexLimitation: Gender[]
    level: ProgramLevel[]
    showFullReservations: boolean
  }
  isMasterFetching: boolean
  isMasterFetched: boolean
  areasByPref: AreasByPref[]
  activities: Activity[]
}

export const initialState = (): SearchState => ({
  conditions: {
    activityIds: [],
    areaIds: [],
    searchDates: [],
    startTimeBefore: '',
    startTimeAfter: '',
    sexLimitation: [],
    level: [],
    showFullReservations: true,
  },
  isMasterFetching: false,
  isMasterFetched: false,
  areasByPref: [],
  activities: [],
})
